import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  getColor,
  Icons,
  InputField,
  Typography,
  useComponentVisible,
} from "fds";
import "./index.scss";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import utilsCommon from "../../shared/utils/common";
import classNames from "classnames";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import useMeetingStore from "../../redux/dispatcher/useMeetingStore";
import { INIT_CONTENT_FILTER, INIT_MEETING_FILTER } from "../../pages/Search";
import { DocInfo } from "../../types/files";
import { meetingDTO } from "../../types/meeting";
import dayjs from "dayjs";
import utilsDocs from "../../shared/utils/docs";
import { getWorkspaceName } from "../../shared/utils/auth";
interface RevisionTagProps {
  classes?: string;
}
const RootSearchbar: React.FC<RevisionTagProps> = ({ classes }) => {
  const navigate = useNavigate();
  const myId = utilsCommon.getMyId();
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const inputRef = useRef();
  const { getContentList } = useDocumentStore();
  const { getMeetingListBySearchKeyword } = useMeetingStore();
  const [searchWord, changeSearchWord] = useState("");
  const [keywords, changeKeywords] = useState<string[]>([]);
  const [showDocList, changeShowDocList] = useState<DocInfo[]>([]);
  const [showMeetingList, changeMeetingList] = useState<meetingDTO[]>([]);
  useEffect(() => {
    changeKeywords(utilsCommon.getKeywordToStorage("" + myId));
    changeShowDocList([]);
    changeMeetingList([]);
  }, []);
  useEffect(() => {
    const searchList = () => {
      getContentList({
        ...INIT_CONTENT_FILTER,
        date: { start: 0, end: dayjs().valueOf() },
        size: 3,
        search: searchWord,
        type: "root_search",
      }).then((resp: any) => {
        changeShowDocList(resp.payload?.docs?.doc);
      });
      getMeetingListBySearchKeyword({
        ...INIT_MEETING_FILTER,
        date: { start: 0, end: dayjs().valueOf() },
        resultSize: 3,
        searchKeyword: searchWord,
        type: "root_search",
      }).then((resp: any) => {
        changeMeetingList(resp.payload.meetingInfoList);
      });
    };
    if (searchWord.trim() !== "") {
      let searchTimer = setTimeout(async () => {
        await searchList();
      }, 1 * 1000); // 1 sec
      return () => clearTimeout(searchTimer);
    }
  }, [searchWord]);
  const handleSubmitKeyword = () => {
    if (!!searchWord.trim()) {
      setIsComponentVisible(false);
      navigate(
        utilsCommon.renderProperNavigatePath(`/search?key=${searchWord.trim()}`)
      );
      utilsCommon.setKeywordToStorage(searchWord.trim(), "" + myId);
      changeKeywords([
        searchWord.trim(),
        ...keywords.filter((item) => item !== searchWord.trim()),
      ]);
    }
  };
  const renderSearchWords = () => {
    return (
      <Box direction="column" classes="headerSearch-under--recommend">
        {showDocList?.length > 0 && (
          <Box direction="column">
            <Box height={20}>
              <Typography
                type="caption_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("common.file")}
              </Typography>
            </Box>
            {showDocList?.map((item) => (
              <Box
                classes={"headerSearch-under--item"}
                onMouseDown={(e: any) => {
                  window.location.href = utilsCommon.renderProperNavigatePath(
                    `/search?key=${item.contentName}`
                  );
                }}
              >
                {utilsDocs.renderDocIcon(item.contentName, 20)}
                <Typography
                  type="body2_rg"
                  ellipsis
                  classes="mg ml-8"
                  width={"calc(100% - 28px)"}
                >
                  {item.contentName}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
        {showMeetingList?.length > 0 && (
          <Box direction="column">
            <Box height={20}>
              <Typography
                type="caption_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("common.meeting")}
              </Typography>
            </Box>
            {showMeetingList?.map((item) => {
              const meetingStatus =
                dayjs(item.endTime).valueOf() > dayjs().valueOf() &&
                dayjs(item.startTime).valueOf() < dayjs().valueOf()
                  ? "live"
                  : dayjs(item.endTime).valueOf() > dayjs().valueOf()
                  ? "waiting"
                  : "finished";

              return (
                <Box
                  classes={"headerSearch-under--item"}
                  onClick={(e: any) => {
                    e.stopPropagation();
                    setIsComponentVisible(false);
                    window.location.href = utilsCommon.renderProperNavigatePath(
                      `/search?key=${item.topic}`
                    );
                  }}
                >
                  <img
                    src={
                      meetingStatus === "waiting"
                        ? require("../../shared/images/pages/Meeting/zoom_waiting.png")
                        : meetingStatus === "live"
                        ? require("../../shared/images/pages/Meeting/zoom_live.png")
                        : require("../../shared/images/pages/Meeting/zoom_finished.png")
                    }
                    width={20}
                    height={meetingStatus === "live" ? 25 : 20}
                    alt="zoom"
                    style={{ display: "flex" }}
                  />
                  <Typography
                    type="body2_rg"
                    ellipsis
                    classes="mg ml-8"
                    width={"calc(100% - 28px)"}
                  >
                    {item.topic}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    );
  };
  const renderKeywords = () => {
    return keywords
      .filter((item, index) => index < 5)
      .map((item) => (
        <Box
          classes={"headerSearch-under--item"}
          onClick={(e: any) => {
            e.stopPropagation();
            setTimeout(() => {
              navigate(
                utilsCommon.renderProperNavigatePath(
                  `/search?key=${encodeURIComponent(item.trim())}`
                )
              );
            }, 0);
            setIsComponentVisible(false);
          }}
        >
          <Icons variant="line" label="history" />
          <Typography
            type="body2_rg"
            ellipsis
            classes="mg ml-8"
            width={"calc(100% - 48px)"}
          >
            {item}
          </Typography>
          <Box
            classes={"headerSearch-under--button"}
            onClick={(e: any) => {
              e.stopPropagation();
              utilsCommon.deleteKeywordToStorage(item, "" + myId);
              changeKeywords(keywords.filter((item1) => item1 !== item));
            }}
          >
            <Icons variant="line" label="closeLine" />
          </Box>
        </Box>
      ));
  };
  const showDropdown =
    (searchWord.trim() == "" && keywords.length > 0) ||
    (searchWord.trim() !== "" &&
      (showDocList?.length > 0 || showMeetingList?.length > 0));
  return (
    <Box
      direction="column"
      classes={classNames("headerSearch", { active: isComponentVisible })}
      ref={ref}
    >
      <InputField
        placeholder={t("search.placeholder")}
        size="md"
        onKeyUp={(e) => e.code === "Enter" && handleSubmitKeyword()}
        maxLength={50}
        ref={inputRef}
        value={searchWord}
        onChange={(e) => changeSearchWord(e.target?.value)}
        onClickInputField={() => setIsComponentVisible(true)}
        leadingIcon={
          <Icons
            variant="line"
            label="search"
            stroke={getColor("COLOR_ICON_INTERACTIVE_TERTIARY")}
          />
        }
      />
      {showDropdown && <Box classes={"headerSearch-divider"} />}
      {showDropdown && (
        <Box classes={"headerSearch-under"}>
          {searchWord.trim() === "" ? renderKeywords() : renderSearchWords()}
        </Box>
      )}
    </Box>
  );
};
export default RootSearchbar;
